import { Card, CardContent, CardHeader } from '@material-ui/core'
import React from 'react'

const TopSelling = () => {
    return (
        <Card>
            <CardHeader
                title='Top Selling'
            />
            <CardContent>
                table
            </CardContent>
        </Card>
    )
}

export default TopSelling
